import api from './api';

// جلب جميع المستخدمين
export const getUsers = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/auth/users?${queryParams}`);
  return response.data;
};
export const assignRole = async (roleId, userId) => {
  const response = await api.post(`/roles/${roleId}/assign/${userId}`);
  return response.data;
};

// جلب مستخدم معين
export const getUserById = async (id) => {
  const response = await api.get(`/auth/users/${id}`);
  return response.data;
};

// إنشاء مستخدم جديد
export const createUser = async (data) => {
  const response = await api.post('/auth/users', {
    username: data.username,
    email: data.email,
    password: data.password,
    full_name: data.full_name,
    phone: data.phone,
    role_id: data.role_id,  // مهم: use role_id
    permissions: data.permissions,
    is_active: data.is_active
  });
  return response.data;
};

// تحديث مستخدم
export const updateUser = async (id, data) => {
  const response = await api.put(`/auth/users/${id}`, data);
  return response.data;
};

// حذف مستخدم
export const deleteUser = async (id) => {
  const response = await api.delete(`/auth/users/${id}`);
  return response.data;
};

// إعادة تعيين كلمة المرور
export const resetUserPassword = async (id, newPassword) => {
  const response = await api.post(`/auth/users/${id}/reset-password`, { password: newPassword });
  return response.data;
};

// تعطيل/تفعيل مستخدم
export const toggleUserStatus = async (id, isActive) => {
  const response = await api.patch(`/auth/users/${id}/status`, { is_active: isActive });
  return response.data;
};
